import React, { useEffect, useContext } from "react";
import { Route, Routes } from "react-router-dom";
import Login from "./Auth/Login";
import { useNavigate } from "react-router-dom";
import PrivateRoute from "./Helper/PrivateRoute";
import PWAPrompt from "react-ios-pwa-prompt";
import OneSignal from "react-onesignal";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { AuthContext } from "./Api/authReq";
import { useDispatch } from "react-redux";
import { setToday } from "./Redux/Actions/PannelAction";
import moment from "jalali-moment";
import Orders from "./TechApp/Components/Orders/Orders";
import Transactions from "./TechApp/Components/Transactions/Transactions";
import Tickets from "./TechApp/Components/Tickets/Tickets";
import Survey from "./TechApp/Components/survey";
import Profile from "./TechApp/Components/Profile/Profile";
import ViewTicket from "./TechApp/Pages/ViewTicket";
import CreateTicket from "./TechApp/Pages/CreateTicket";
import SearchPage from "./TechApp/Pages/SearchPage";
import ExpiredOrders from "./TechApp/Pages/ExpiredOrders";
import BugReport from "./TechApp/Pages/bug-report/bug-report";
import Stats from "./TechApp/Pages/stats";
import DefineCost from "./TechApp/Pages/DefineCost";
import ViewOrder from "./TechApp/Pages/ViewOrder";
import Complaint from "./TechApp/Pages/Complaint";
import { techappContext } from "./Api/techappReq";
import Loading from "./TechApp/Components/loading";

const App = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setFcmToken } = useContext(AuthContext);
  const firebaseConfig = {
    apiKey: "AIzaSyABtgyuAtLX9YwTZANOatHtYvAq2L7P9YI",
    authDomain: "karabama-service.firebaseapp.com",
    databaseURL: "https://karabama-service.firebaseio.com",
    projectId: "karabama-service",
    storageBucket: "karabama-service.appspot.com",
    messagingSenderId: "371314824510",
    appId: "1:371314824510:web:ce8533df04a1ff57a8886f",
    measurementId: "G-FXFWD2T6SV",
  };

  const app = initializeApp(firebaseConfig);
  const messaging = getMessaging(app);

  // const orderObj = useSelector((state) => state.TechAppReducer.orderObj);
  // const profileData = useSelector((state) => state.TechAppReducer.profileData);

  useEffect(() => {
    let todayYear = parseInt(moment().locale("fa").format("YYYY"));
    let todayMonth = parseInt(moment().locale("fa").format("MM"));
    let todayDay = parseInt(moment().locale("fa").format("DD"));
    dispatch(setToday({ year: todayYear, month: todayMonth, day: todayDay }));
    if ("caches" in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
    if (localStorage.getItem("token")) {
      navigate("/techapp");
    } else {
      navigate("/");
    }
    OneSignal.init({ appId: "43fa58d9-70b0-4434-b3ae-49494e92a84e" }).then(
      () => {
        OneSignal.showSlidedownPrompt().then((res) => {
          console.log(res);
        });
      }
    );
    getToken(messaging, {
      vapidKey:
        "BFroVq3xUZngIVrfrOj0HPk1ESIlEfulxeA0bC870L6lIWySpcM0h0oaz1n96oZnXzxKaJITIthkaIbV6pHZIQ8",
    })
      .then((currentToken) => {
        if (currentToken) {
          setFcmToken(currentToken);
          // Perform any other neccessary action with the token
        } else {
          // Show permission request UI
          console.log(
            "No registration token available. Request permission to generate one."
          );
        }
      })
      .catch((err) => {
        console.log("An error occurred while retrieving token. ", err);
      });
  }, []);


  return (
    <div className="combinedapp">
      <PWAPrompt
        copyTitle="Karabama Technician App"
        permanentlyHideOnDismiss={false}
        timesToShow={2}
      />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/techapp" element={<PrivateRoute />}>
          <Route index element={<Orders />} />
          <Route path="/techapp/transactions" element={<Transactions />} />
          <Route path="/techapp/tickets" element={<Tickets />} />
          <Route path="/techapp/survey" element={<Survey />} />
          <Route path="/techapp/profile" element={<Profile />} />
          <Route path="/techapp/view-ticket" element={<ViewTicket />} />
          <Route path="/techapp/create-ticket" element={<CreateTicket />} />
          <Route path="/techapp/search" element={<SearchPage />} />
          <Route path="/techapp/expired" element={<ExpiredOrders />} />
          <Route path="/techapp/bug-report" element={<BugReport />} />
          <Route path="/techapp/stats" element={<Stats />} />
          <Route path="/techapp/define-cost" element={<DefineCost />} />
          <Route path="/techapp/view-order" element={<ViewOrder />} />
          <Route path="/techapp/complaint" element={<Complaint />} />
        </Route>
      </Routes>
    </div>
  );
};
export default App;
